// Module
var code = "<div class='alert'>\n\t<div>\n        <h1>\n            Курс пилотов ПАДЦЕВ™ оптимизирован для планшетов и персональных компьютеров.\n            \n        </h1>\n        <h2>Если вы видите это сообщение на планшете или персональном компьютере — возможно, вам следует изменить настройки или ориентацию экрана.</h2>\n\t</div>\n</div> \n";
// Exports
module.exports = code;